import { httpClient } from "@/app/client/httpClient";

class SmsService {
  createSms(body: { phoneNumber: string }) {
    return httpClient.sms.$post({
      body
    });
  }

  createPhoneRequest(body: { phoneNumber: string }) {
    return httpClient.sms.phone_request.$post({
      body
    });
  }

  validateSms(body: { latestPin: string; phoneNumber: string }) {
    return httpClient.sms.validate.$post({
      body
    });
  }

  validatePhoneRequest(body: { latestPin: string; phoneNumber: string }) {
    return httpClient.sms.validate.phone_request.$post({
      body
    });
  }

  createSmsPasswordReset(body: { phoneNumber: string }) {
    return httpClient.sms.sms_password_reset.$post({
      body
    });
  }

  validateSmsPasswordReset(body: { latestPin: string; phoneNumber: string }) {
    return httpClient.sms.validate.sms_password_reset_validate.$post({
      body
    });
  }
}

export const smsService = new SmsService();
